'use strict';

exports.__esModule = true;
var RELATIVE_TYPES = exports.RELATIVE_TYPES = {
  LOAD: 'RELATIVE_TYPES_LOAD',
  SUCCESS: 'RELATIVE_TYPES_LOAD_DONE',
  FAIL: 'RELATIVE_TYPES_LOAD_FAIL'
};

var loadRelativeTypes = exports.loadRelativeTypes = function loadRelativeTypes(language) {
  return {
    type: RELATIVE_TYPES.LOAD,
    language: language
  };
};

var loadRelativeTypesSuccess = exports.loadRelativeTypesSuccess = function loadRelativeTypesSuccess() {
  return {
    type: RELATIVE_TYPES.SUCCESS
  };
};

var loadRelativeTypesFail = exports.loadRelativeTypesFail = function loadRelativeTypesFail(relativeTypes) {
  return {
    type: RELATIVE_TYPES.FAIL,
    relativeTypes: relativeTypes
  };
};